import YIcon from './src/main'

YIcon.install = function(Vue) {
  Vue.component(YIcon.name, YIcon)
}

export default YIcon
